import config from "../../config";

const apiCSPEndpoint = config.apiCSPEndpoint;

export default apiCSPEndpoint;
